var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_3990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 11.2797V13.2797C14.6684 13.4654 14.6303 13.6492 14.5559 13.8193C14.4816 13.9894 14.3725 14.1421 14.2356 14.2676C14.0988 14.3932 13.9373 14.4887 13.7614 14.5482C13.5855 14.6077 13.3992 14.6298 13.2143 14.6131C11.1628 14.3902 9.19226 13.6892 7.46093 12.5664C5.85015 11.5428 4.48449 10.1772 3.46093 8.56641C2.33425 6.82721 1.63309 4.84707 1.41426 2.78641C1.3976 2.60205 1.41951 2.41625 1.4786 2.24082C1.53768 2.0654 1.63264 1.9042 1.75744 1.76749C1.88224 1.63077 2.03413 1.52155 2.20346 1.44675C2.37278 1.37196 2.55582 1.33325 2.74093 1.33307H4.74093C5.06447 1.32989 5.37812 1.44446 5.62344 1.65543C5.86875 1.8664 6.02898 2.15937 6.07426 2.47974C6.15868 3.11978 6.31523 3.74822 6.54093 4.35307C6.63063 4.59169 6.65004 4.85102 6.59687 5.10033C6.5437 5.34964 6.42017 5.57848 6.24093 5.75974L5.39426 6.60641C6.3433 8.27544 7.72523 9.65737 9.39426 10.6064L10.2409 9.75974C10.4222 9.5805 10.651 9.45697 10.9003 9.4038C11.1497 9.35063 11.409 9.37004 11.6476 9.45974C12.2524 9.68544 12.8809 9.84199 13.5209 9.92641C13.8448 9.97209 14.1405 10.1352 14.352 10.3847C14.5634 10.6343 14.6757 10.9528 14.6676 11.2797Z",
    stroke: "#525455",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_3990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.e95075114344d9f9587cb999492dd16b.svg";
export { ForwardRef as ReactComponent };